import { ROUTES } from '@/features/core/container';
import { option } from '@/util/container';
import { component } from '../component';
import { APP_CUSTOMER } from './app.builder';

export default option(ROUTES, async () => {
  return [
    {
      path: '/customer/:customerId/vendor-apis/generic-notification-api/:thirdpartyConfigId',
      component: component('views/generic-notification-api/GenericNotificationApiView.vue'),
      props: true,
      meta: { app: APP_CUSTOMER, key: (): string => `AppCustomer/VendorApis/GenericNotificationApi` },
      children: [
        {
          path: '/customer/:customerId/vendor-apis/generic-notification-api/:thirdpartyConfigId',
          name: 'AppCustomer/VendorApis/GenericNotificationApi',
          meta: { app: APP_CUSTOMER },
          beforeEnter: ({ params }, from, next) =>
            void next({ name: 'AppCustomer/VendorApis/GenericNotificationApi/Settings', params }),
        },
        {
          path: 'settings',
          name: 'AppCustomer/VendorApis/GenericNotificationApi/Settings',
          component: component('views/generic-notification-api/settings/SettingsView.vue'),
          props: true,
          meta: { app: APP_CUSTOMER },
        },
      ],
    },
  ];
});
